const app = angular.module('navApp', ['ngAnimate', 'ngSanitize']).factory('_', [
  '$window', function($window) {
    return $window._;
  }
]).factory('hoverIntent', [
  '$window', function($window) {
    return $window.hoverIntent;
  }
]).factory('endpointDomain', [
  '$window', function($window) {
    if (($window.ngNavData.endpointDomain != null) && $window.ngNavData.endpointDomain.length > 0) {
      return $window.ngNavData.endpointDomain;
    } else {
      return '/';
    }
  }
]).factory('localNavDataUrl', [
  '$window', function($window) {
    return $window.ngNavData.localNavDataUrl || null;
  }
]).constant('templatePrefix', '/typo3conf/ext/t3site/Sites/Main/Resources/Assets/Script/Coffeescript/Nav/templates').constant('animateSpeed', 300);

app.factory('templatePath', [
  'templatePrefix', function(templatePrefix) {
    return function(file) {
      return templatePrefix + "/" + file;
    };
  }
]);

const navApp = app;

export default navApp;
